export type LineThickness = 1 | 2 | 3 | 4

/** All five lightweight-charts line styles */
export type ChartLineStyle = 'solid' | 'dotted' | 'dashed' | 'large_dashed' | 'sparse_dotted'

export type LineStyleProps = {
    lineThickness?: LineThickness
    lineStyle?: ChartLineStyle
    onLineThicknessChange?: (thickness: LineThickness) => void
    onLineStyleChange?: (style: ChartLineStyle) => void
}

export const clampLineThickness = (thickness?: number): LineThickness => {
    const value = thickness ?? 2
    if (value <= 1) return 1
    if (value >= 4) return 4
    return value as LineThickness
}

export const getLineDashProps = (style: ChartLineStyle): { strokeDasharray?: string; strokeLinecap?: 'round' | 'butt' } => {
    switch (style) {
        case 'dotted':       return { strokeDasharray: '1 2', strokeLinecap: 'round' }
        case 'dashed':       return { strokeDasharray: '6 3' }
        case 'large_dashed': return { strokeDasharray: '12 4' }
        case 'sparse_dotted': return { strokeDasharray: '2 6', strokeLinecap: 'round' }
        default:             return {}
    }
}

/** Dash segments matching lightweight-charts `setLineStyle` (same as crosshair). */
export const getLineDashPattern = (style: ChartLineStyle, lineWidth: number): number[] => {
    switch (style) {
        case 'dotted':        return [lineWidth, lineWidth]
        case 'dashed':        return [2 * lineWidth, 2 * lineWidth]
        case 'large_dashed':  return [6 * lineWidth, 6 * lineWidth]
        case 'sparse_dotted': return [lineWidth, 4 * lineWidth]
        default:              return []
    }
}
